import { useIsMobile } from "@/hooks/use-mobile";
import { Drawer, DrawerContent, DrawerFooter, DrawerHeader } from "./ui/drawer";
import { Dialog, DialogContent, DialogFooter, DialogHeader } from "./ui/dialog";
import { ReactNode } from "react";

export function ResponsiveDialog({
  children,
  onClose,
  open,
}: {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}) {
  const isMobile = useIsMobile();
  if (!open) return <></>;
  if (isMobile)
    return (
      <Drawer open onClose={onClose}>
        <DrawerContent>
          <div className="mx-auto max-h-[90dvh] w-full max-w-lg overflow-y-auto px-4">
            <DrawerHeader></DrawerHeader>
            {children}
            <DrawerFooter></DrawerFooter>
          </div>
        </DrawerContent>
      </Drawer>
    );

  return (
    <Dialog
      open
      onOpenChange={(o) => {
        if (o) return;
        onClose();
      }}
    >
      <DialogContent className="max-h-[90dvh] overflow-y-auto sm:max-w-[425px]">
        <DialogHeader></DialogHeader>
        {children}
        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
